import type { AppConfig } from '../types/config.types';
import { normalizeTenantCountry } from './countryConfig';

export type SettingsSectionsConfig = Pick<
  AppConfig,
  'country' | 'isGuaranteesEnabled' | 'isQuotationsEnabled'
>;

export function isQuotationsSettingsGateEnabled(
  config: SettingsSectionsConfig,
): boolean {
  return Boolean(config.isGuaranteesEnabled || config.isQuotationsEnabled);
}

export function showCommissionsConfigurationSection(
  config: SettingsSectionsConfig,
): boolean {
  return (
    isQuotationsSettingsGateEnabled(config) &&
    normalizeTenantCountry(config.country) !== 'URUGUAY'
  );
}
